//TODO: Similar function already exists in "accountStoreModule", make it generic
const SET_FAVORITE_STORE = 'rest/model/atg/userprofiling/ProfileActor/setUsualStore';

const storeCookieName = 'CUSTOMER_STORE';

/**
 * Set a store as customer favorite store
 *
 * @param {string} _storeId mandatory
 * @param {function} _callback optional
 */
export function setAsFavoriteStore(_storeId, _callback = null) {
  cube.ajax
    .post(SET_FAVORITE_STORE, { storeId: _storeId })
    .onSuccess(() => {
      const storePage = cube.$('.store-page');

      if (storePage) refreshStorePage();
      if (_callback) _callback();

      setStoreCookie();
    })
    .call();
}


/**
 * Refresh favorite store block when the customer is on the store-page
 *
 */
function refreshStorePage () {
  cube.$id('select-favorite-store').style.display = 'none';
  cube.$id('favorite-store').checked = true;
  cube.$id('is-favorite-store').style.display = 'block';
}


/**
 * Set a CUSTOMER_STORE cookie containing a JSON representation of the store
 * { storeId, storeName }
 */
export function setStoreCookie() {
  let storeCookieValue = (document.cookie || '').split(';').find((str) => str.indexOf(storeCookieName) > -1);

  if (tc_vars) {
    const storeId = tc_vars.user_navigation_store_id;
    const storeName = tc_vars.user_navigation_store_name;
    if (storeId && storeName) {
      storeCookieValue = {
        storeId,
        storeName
      };
      const expiryDate = new Date();
      expiryDate.setTime(expiryDate.getTime() + (365 * 24 * 60 * 60 * 1000));
      storeCookieValue = encodeURIComponent(JSON.stringify(storeCookieValue));
      document.cookie = `${storeCookieName}=${storeCookieValue}; expires=${expiryDate.toUTCString()}; path=/`;
    } else {
      removeStoreCookie();
    }
  }
}

/**
 * Set a CUSTOMER_STORE cookie containing a JSON representation of the store
 * { storeId, storeName }
 */
export function removeStoreCookie() {
  document.cookie = `${storeCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}



// WEBPACK FOOTER //
// ./src/commons/header/header-store-locator.js